import React from 'react';
import { useParams } from 'react-router-dom';
import RecruitmentPlanJobList from './RecruitmentPlanJobList';

const RecruitmentPlanJobIfpList = () => {

    const { planIdParam } = useParams();

    return (
        <RecruitmentPlanJobList recuitmentPlanId={planIdParam} type="INALTI_FUNCTIONARI_PUBLICI"/>
    );
};

export default RecruitmentPlanJobIfpList;
